<template lang="html">

  <section class="home-alumno">

    <template v-if="brand.banner_home">
      <div class="contenedor-banner container">
        <router-link v-if="!brand.banner_home.external" :to="brand.banner_home.link">
          <img :src="brand.banner_home.src" alt="">
        </router-link>

        <a v-if="brand.banner_home.external" :href="brand.banner_home.link">
          <img :src="brand.banner_home.src" alt="">
        </a>

      </div>
    </template>

    <div class="contenedor-modulos">

      <div class="container row-between ais -superior"
        :hascomunicaciones="(comunicaciones.length > 0) ? 'true' : 'false'" :center="soloCiclosUAX">

        <div class="contenedor-modulo-ofertas column-center" v-if="!soloCiclosUAX">
          <modulo-ofertas></modulo-ofertas>
        </div>

        <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0" :full="soloCiclosUAX">
          <modulo-comunicaciones></modulo-comunicaciones>
        </div>

      </div>

      <div class="contenedor-encuestas">

        <modulo-encuestas></modulo-encuestas>

      </div>

      <div class="contenedor-modulo-eventos" v-if="brand.hasEventos">
        <modulo-eventos></modulo-eventos>
      </div>


      <div class="contenedor-guias-orientacion" v-if="brand.hasGuiasOrientacion">
        <modulo-guias></modulo-guias>
      </div>

      <modulo-actualidad :esHome="true"></modulo-actualidad>

      <modulo-recursos :esHome="true"></modulo-recursos>

      <!--<div class="contenedor-guias-orientacion info-Alumno" v-if="brand.infoAlumno">
         {{ $t('encabezado.info_alumno') }}
      </div>-->
      
      <div class="cover-popup row-center" v-if="mostrarMensajeSS">
        <div class="popup">
          <a @click="hideMensaje" class="close">✕</a>
          <p>{{ $t('encabezado.falta_num_ss') }}</p>

          <div class="contenedor-botones row-center">
            <router-link  :to="$t('enlaces.cv')" class="btn -solid-primary">{{$t('header.mi_cv') }}</router-link>
          </div>
        </div>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import moduloOfertas from './modulo-ofertas';
  import moduloComunicaciones from './modulo-comunicaciones';
  import moduloEventos from './modulo-eventos';
  import moduloGuias from './modulo-guias';

  import moduloEncuestas from '@/components/views/home/modulo-encuestas'

  import moduloActualidad from '@/components/views/noticias/actualidad'
  import moduloRecursos from '@/components/views/noticias/recursos'

  import { mapGetters } from 'vuex'

  export default {
    name: 'home-alumno',
     methods : {
      hideMensaje : function(){
        this.mostrarMensajeSS = false;
      },
    },
   data(){
      return {
        mostrarMensajeSS : '',
      }
    },
    components: {
      'modulo-ofertas': moduloOfertas,
      'modulo-comunicaciones': moduloComunicaciones,
      'modulo-encuestas': moduloEncuestas,
      'modulo-eventos': moduloEventos,
      'modulo-guias': moduloGuias,
      'modulo-actualidad': moduloActualidad,
      'modulo-recursos': moduloRecursos,
    },
    computed: {
      ...mapGetters({
        colors: 'basicColors',
        comunicaciones: 'getComunicaciones',
        brand: 'getBrand',
        soloCiclosUAX : 'getsoloCiclosUAX',
        tieneNumSS: 'gettieneNumSegSocial'
      })
    },
    watch :{
      'tieneNumSS'(){
        //no se muestra en CUNEF
        this.mostrarMensajeSS = false;//!this.tieneNumSS;
      }
    }
  }
</script>

<style scoped lang="scss">
  .popup {
    min-height: 150px;
    min-width: 50%;
  }

  .popup p {
    width: 100%;
    text-align: left;
    font-weight: bold;
    color: black;
  }

  .home-alumno {
    min-height: calc(100vh - 309px);
  }

  .contenedor-banner {
    img {
      max-width: 100%;
      cursor: pointer;
    }
  }

  .contenedor-modulos {
    padding-top: 50px;
  }

  .contenedor-modulos .-superior {
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;
    max-width: 1200px;

    &[center="true"]{
      justify-content: center;
    }

    &[hascomunicaciones="false"] {
      justify-content: center;
      -webkit-justify-content: center;
    }
  }

  .contenedor-modulo-ofertas {
    width: 100%;
    max-width: 768px;
    padding-right: 25px;
  }


  .contenedor-modulo-eventos {
    width: 100%;
    margin-top: 50px;
    padding: 50px 0;
  }

  .contenedor-guias-orientacion {
    margin-top: 50px;
  }

  @media screen and (max-width: 868px) {

    .contenedor-modulos {
      padding-top: 25px;
    }

    .contenedor-modulos .-superior {
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      -o-flex-wrap: wrap;
      flex-wrap: wrap;

    }

    .contenedor-modulo-ofertas {
      width: 100%;
      padding-right: 0;
      max-width: 100%;
    }

    .contenedor-modulo-comunicaciones {
      width: 100%;
      margin-top: 50px;
      max-width: 100%;
    }

  }

  @media screen and (max-width: 500px) {

    .contenedor-modulo-comunicaciones {
      margin-top: 25px;
    }

    .contenedor-modulo-eventos {
      margin-top: 25px;
      padding-top: 25px;
    }
  }

  .info-Alumno{
    font-weight: bold;
    padding-left: 20%;
    padding-right: 20%;
    font-size: 15px
  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/home-alumno.vue